import serverCall from "../serverCall";

const getHistory = (date, pageNumber, pageSize, country) => {
  const response = serverCall.get(
    `/admin/history?date=${date}&pageNumber=${pageNumber}&pageSize=${pageSize}&country=${country}`
  );
  return response;
};

const getLogMessages = (
  endDate,
  message,
  mobileNumber,
  pagenumber,
  pageSize,
  startDate
) => {
  const response = serverCall.post(
    `/messages/log?endDate=${endDate}&message=${message}&mobileNumber=${mobileNumber}&pageSize=${pageSize}&pagenumber=${pagenumber}&startDate=${startDate}`
  );
  return response;
};

// Device registrations (silent self-loopback verifications) — the SEPARATE log,
// distinct from delivery-test messages. Backend: GET /admin/registrations.
const getRegistrations = () => {
  return serverCall.get(`/admin/registrations`);
};

const HistoryService = {
  getHistory,
  getLogMessages,
  getRegistrations,
};

export default HistoryService;
